export default "__VITE_ASSET__BqARRLJw__"